<template>
  <main class="app-content">
    <div class="app-title">
      <h1><i class="fa fa-dashboard"></i> {{ $t('usageReport') }}</h1>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab">
          <b-tab>
            <template #title>
              {{ $t('quantityUsed') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('topFeatures') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('activityLevel') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('frequencyOfUse') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <quantity-used v-if="tab === 0"></quantity-used>
    <top-features v-if="tab === 1"></top-features>
    <activity-level v-if="tab === 2"></activity-level>
    <frequency-of-use v-if="tab === 3"></frequency-of-use>
  </main>
</template>

<script>
import QuantityUsed from "@/views/report/usage/QuantityUsed.vue";
import TopFeatures from "@/views/report/usage/TopFeatures.vue";
import ActivityLevel from "@/views/report/usage/ActivityLevel.vue";
import FrequencyOfUse from "@/views/report/usage/FrequencyOfUse.vue";

export default {
  components: {QuantityUsed, TopFeatures, ActivityLevel, FrequencyOfUse},
  data() {
    return {
      tab: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        usageReport: 'Usage report',
        quantityUsed: 'Quantity used',
        topFeatures: 'Top features',
        activityLevel: 'Activity level',
        frequencyOfUse: 'Frequency of use',
      },
      vi: {
        usageReport: 'Báo cáo sử dụng',
        quantityUsed: 'Lượt sử dụng',
        topFeatures: 'Top tính năng',
        activityLevel: 'Mức độ hoạt động',
        frequencyOfUse: 'Tần suất sử dụng',
      }
    }
  }
}
</script>